import React, {useState, useEffect} from 'react';

export default function Search({showSearch = false, searchValue = '', onChangeSearch, showNew = false, handleNew, debounceMs = 1000, children, actionButtons = null}) {
	const [timerId, setTimerId] = useState(null);
	const [value, setValue] = useState('');
	const [lastSearchValue, setLastSearchValue] = useState('');

	useEffect(() => {
		setValue(searchValue);
		setLastSearchValue(searchValue);
	}, [searchValue]);

	const goSearch = (e) => {
		onChangeSearch(e);
		setLastSearchValue(e);
	};

	const handleChange = (e) => {
		setValue(e.target.value);

		if (timerId) {
			clearTimeout(timerId);
		}

		if (debounceMs <= 0) {
			goSearch(e.target.value);
			setTimerId(null);
			return;
		}

		const newTimerId = setTimeout(() => {
			goSearch(e.target.value);
		}, debounceMs);

		setTimerId(newTimerId);
	};

	const cancelSearch = (e) => {
		if (timerId) {
			clearTimeout(timerId);
		}

		if (lastSearchValue !== '') {
			goSearch('');
		}

		setValue('');
	};

	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			if (timerId) {
				clearTimeout(timerId);
			}

			goSearch(value);
		}
	};

	return (
		<div className="top">
			{showSearch ? (
				<>
					<div className="search-field fl_l pos_r mr_1">
						<input className="input-text input-text-search" type="text" placeholder="Vyhledat" value={value} onChange={(e) => handleChange(e)} onKeyDown={(e) => handleKeyDown(e)} />
						{value !== '' ? <button type="button" className="input-text-search-del" onClick={() => cancelSearch()} aria-label="Smazat vyhledavani"></button> : ''}
					</div>
				</>
			) : (
				''
			)}

			{children}

			{showNew || actionButtons ? (
				<div className="fl_r" style={{display: 'inline-flex', alignItems: 'center', gap: '0.7rem'}}>
					{actionButtons}
					{showNew ? (
						<button className="button small search-new-button" onClick={() => handleNew()}>
							Nový
						</button>
					) : (
						''
					)}
				</div>
			) : (
				''
			)}
		</div>
	);
}
